var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2818_11176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.252 0C17.6662 0 18.002 0.335786 18.002 0.75V3H21.752C22.9946 3 24.002 4.00736 24.002 5.25V21.75C24.002 22.9926 22.9946 24 21.752 24H2.25195C1.00931 24 0.00195312 22.9926 0.00195312 21.75V5.25C0.00195312 4.00736 1.00931 3 2.25195 3H6.00195V0.75C6.00195 0.335786 6.33774 0 6.75195 0C7.16617 0 7.50195 0.335786 7.50195 0.75V3H16.502V0.75C16.502 0.335786 16.8377 0 17.252 0ZM1.50195 21.75C1.50195 22.1642 1.83774 22.5 2.25195 22.5H21.752C22.1662 22.5 22.502 22.1642 22.502 21.75V10.5H1.50195V21.75ZM2.25195 4.5C1.83774 4.5 1.50195 4.83579 1.50195 5.25V9H22.502V5.25C22.502 4.83579 22.1662 4.5 21.752 4.5H18.002V6C18.002 6.41421 17.6662 6.75 17.252 6.75C16.8377 6.75 16.502 6.41421 16.502 6V4.5H7.50195V6C7.50195 6.41421 7.16617 6.75 6.75195 6.75C6.33774 6.75 6.00195 6.41421 6.00195 6V4.5H2.25195Z",
    fill: "#007191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2818_11176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.53fe93cd627cc2f2aea2961ad3f601b3.svg";
export { ForwardRef as ReactComponent };